module.exports = __webpack_public_path__ + "static/media/washington_jardin.7e5a3d93.jpg";